module.exports = __webpack_public_path__ + "static/media/attach-video.ad64d3db.svg";